import { ShieldX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button.js';

/**
 * Shown when the customer's role doesn't authorize the page they
 * landed on (Casbin-equivalent gate). Mirrors legacy
 * `wf-audit/src/slices/common/components/AccessDenied.tsx`. The
 * message is overridable so per-route gates can describe the
 * specific permission requirement.
 */
export function AccessDeniedPage({
  message = 'You do not have permission to access this page. Please contact your administrator.',
}: {
  message?: string;
}): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="relative z-10 flex min-h-[calc(100vh-7rem)] items-center justify-center p-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <ShieldX className="h-16 w-16 text-red-600 dark:text-red-400" />
        <h2 className="text-xl font-semibold text-foreground">Access Denied</h2>
        <p className="max-w-md text-sm text-foreground/60">{message}</p>
        <Button type="button" onClick={() => navigate(-1)} className="mt-2">
          Go Back
        </Button>
      </div>
    </div>
  );
}
